export default class BestellungFilialeRequest {
  identifierId: string
  filialeId: string
}
